import axios from 'axios'
import apiClient from '../client'


export const wordPressService = {
  // Get available actions
  getAvailableActions: async () => {
    const response = await apiClient.get('/wordpress/actions')
    return response.data
  },

  // Generic WordPress action endpoint
  executeAction: async (actionData) => {
    const response = await apiClient.post('/wordpress', actionData)
    return response.data
  },

  // Test WordPress Connection
  testConnection: async (connectionId) => {
    const response = await apiClient.post('/wordpress', {
      connectionId,
      action: 'test-connection',
    })
    return response.data
  },

  // Get WordPress Site Info
  getSiteInfo: async (connectionId) => {
    const response = await apiClient.post('/wordpress', {
      connectionId,
      action: 'get-site-info',
    })
    return response.data
  },

  // Get WordPress Pages
  getPages: async (connectionId) => {
    const response = await apiClient.post('/wordpress', {
      connectionId,
      action: 'get-pages',
    })
    return response.data
  },

  // Scan Page
  scanPage: async (connectionId, pageId = null, pageUrl = null, wcagLevel = 'wcag2aa') => {
    const payload = {
      connectionId,
      action: 'scan-page',
      wcagLevel,
    }
    if (pageId) payload.pageId = pageId
    if (pageUrl) payload.pageUrl = pageUrl

    const response = await apiClient.post('/wordpress', payload)
    return response.data
  },

  // Apply Fixes
  applyFixes: async (connectionId, fixes = [], pageId = null, pageUrl = null) => {
    const payload = {
      connectionId,
      action: 'apply-fixes',
      fixes,
    }
    if (pageId) payload.pageId = pageId
    if (pageUrl) payload.pageUrl = pageUrl

    const response = await apiClient.post('/wordpress', payload)
    return response.data
  },

// Rollback Fixes - Get rollback info preview
  getRollbackInfo: async (connectionId, pageUrl) => {
    const response = await apiClient.get('/wordpress/accessibility/rollback-info', {
      params: { connectionId, pageUrl }
    })
    return response.data
  },

  // Rollback Fixes - Execute rollback
  rollbackFixes: async (connectionId, pageUrl, nestedSelectors = []) => {
    const payload = { connectionId, pageUrl }
    if (nestedSelectors && nestedSelectors.length > 0) {
      payload.nestedSelectors = nestedSelectors
    }
    const response = await apiClient.post('/wordpress/accessibility/rollback', payload)
    return response.data
  },

  // Get Scan History
  getScanHistory: async (connectionId, pageId = null, pageUrl = null, limit = 10, format = 'json') => {
    const payload = {
      connectionId,
      action: 'get-scan-history',
      limit,
      format,
    }
    if (pageId) payload.pageId = pageId
    if (pageUrl) payload.pageUrl = pageUrl

    const response = await apiClient.post('/wordpress', payload)
    return response.data
  },

  // Get Applied Fixes
  getAppliedFixes: async (connectionId, pageId = null, pageUrl = null) => {
    const payload = {
      connectionId,
      action: 'get-applied-fixes',
    }
    if (pageId) payload.pageId = pageId
    if (pageUrl) payload.pageUrl = pageUrl

    const response = await apiClient.post('/wordpress', payload)
    return response.data
  },

  // Get Accessibility Report
  getAccessibilityReport: async (connectionId, pageId = null, pageUrl = null, format = 'json') => {
    const payload = {
      connectionId,
      action: 'get-accessibility-report',
      format,
    }
    if (pageId) payload.pageId = pageId
    if (pageUrl) payload.pageUrl = pageUrl

    const response = await apiClient.post('/wordpress', payload)
    return response.data
  },

  // Export Results
  exportResults: async (connectionId, pageId = null, pageUrl = null, format = 'json') => {
    const payload = {
      connectionId,
      action: 'export-results',
      format,
    }
    if (pageId) payload.pageId = pageId
    if (pageUrl) payload.pageUrl = pageUrl

    const response = await apiClient.post('/wordpress', payload)
    return response.data
  },

  // Get Violations
  getViolations: async (connectionId, pageId = null, pageUrl = null, filters = {}) => {
    const payload = {
      connectionId,
      action: 'get-violations',
      ...filters,
    }
    if (pageId) payload.pageId = pageId
    if (pageUrl) payload.pageUrl = pageUrl

    const response = await apiClient.post('/wordpress', payload)
    return response.data
  },

  // Get AI Fixes
  getAiFixes: async (violations = [], apiKey, pageUrl = null, baseUrl = null, pageBuilder = null, pageId = null, scanResultId = null, platform = 'wordpress', body = null, styles = null) => {
    const payload = {
      violations,
      apiKey,
    }
    if (pageUrl) payload.page_url = pageUrl
    if (baseUrl) payload.base_url = baseUrl
    if (scanResultId) payload.resultId = scanResultId
    if (body !== undefined && body !== null) payload.body = body
    if (styles !== undefined && styles !== null) payload.styles = styles
    if (platform === 'wordpress') {
      if (pageBuilder) payload.page_builder = pageBuilder
      if (pageId) payload.pageId = pageId
    }

    const response = await apiClient.post('/wordpress/accessibility/get-ai-fixes', payload, {
      // Backend allows this route 20 minutes; wait slightly longer so its own
      // timeout response reaches the user instead of the client aborting first.
      timeout: 21 * 60 * 1000,
    })
    return response.data
  },

  // Legacy methods for backward compatibility (using connectionId from website connections)
  testConnectionLegacy: async (siteUrl, apiKey) => {
    const response = await apiClient.post('/wordpress', {
      action: 'test-connection',
      siteUrl,
      apiKey,
    })
    return response.data
  },

  getSiteInfoLegacy: async (siteUrl, apiKey) => {
    const response = await apiClient.post('/wordpress', {
      action: 'get-site-info',
      siteUrl,
      apiKey,
    })
    return response.data
  },

  getPagesLegacy: async (siteUrl, apiKey) => {
    const response = await apiClient.post('/wordpress', {
      action: 'get-pages',
      siteUrl,
      apiKey,
    })
    return response.data
  },

  // Disconnect Site
  disconnectSite: async (connectionId) => {
    const response = await apiClient.post('/wordpress', {
      connectionId,
      action: 'disconnect-site',
    })
    return response.data
  },

  // // Get WordPress Pages Directly (proxied through backend to avoid CORS)
  getPagesDirectly: async (connectionId) => {
    const response = await apiClient.post('/wordpress', {
      connectionId,
      action: 'get-pages',
    })
    return response.data
  },

  // // Get WordPress Pages Directly (External REST API)
  // getPagesDirectly: async (siteUrl, apiKey) => {
  //   const baseUrl = siteUrl.endsWith('/') ? siteUrl.slice(0, -1) : siteUrl
  //   const response = await axios.get(`${baseUrl}/wp-json/ada-scanner/v1/pages`,
  //     // {
  //     //   headers: {
  //     //     'Authorization': `Bearer ${apiKey}`
  //     //   }
  //     // }
  //   )
  //   return response.data
  // },

  // Apply Fixes Directly (External REST API)
  applyFixesDirectly: async (siteUrl, apiKey, pageUrl, fixes = []) => {
    const baseUrl = siteUrl.endsWith('/') ? siteUrl.slice(0, -1) : siteUrl
    const response = await axios.post(`${baseUrl}/wp-json/ada-scanner/v1/apply-fixes`, {
      page_url: pageUrl,
      fixes: fixes
    }, {
      headers: {
        'Authorization': `Bearer ${apiKey}`
      }
    })
    return response.data
  },
}
